import React from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';

import DialogHeader from 'components/DialogHeader/DialogHeader';
import { AccountDetailStore } from 'stores/account/accountDetailStore';
import { ConfirmType } from 'pages/Accounts/Detail/enums';

interface Props {
  store: AccountDetailStore;
}

const ConfirmEditDialog: React.FC<Props> = ({ store }) => {
  const { t } = useTranslation();
  const confirmType = store.confirmType;
  const cancel =
    confirmType &&
    [ConfirmType.CANCEL_EDIT, ConfirmType.CANCEL_PROCESSING, ConfirmType.CANCEL_SIGNATURE].includes(confirmType);

  return (
    <Dialog open={store.confirmDialog} maxWidth="sm">
      <DialogHeader onClose={store.hideConfirmDialog} />
      <DialogContent>{t(`accountDetail_confirm_${confirmType}`)}</DialogContent>
      <DialogActions>
        <Button
          onClick={async () => {
            store.hideConfirmDialog();
            if (store.isEditMode) {
              store.confirmCancel();
            } else {
              store.confirmEdit();
            }
          }}
          variant="contained"
          color={cancel ? 'default' : 'primary'}
        >
          {t(cancel ? `accountDetail_cancel_${confirmType}` : 'general_ok')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default observer(ConfirmEditDialog);
